import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  useDisclosure,
} from '@chakra-ui/react'
import { useAuthenticatedAccount } from 'src/features/auth/context'
import { ModalCancelButton } from 'src/lib/chakra-theme/components'
import { useMirohaToast } from 'src/lib/chakra-theme/components/toast/use-miroha-toast'

import { useSendWorksheet } from '../../api/sendWorksheet'
import { useWorksheetValueContext } from '../../context/WorksheetValue'
import { WorksheetDetail, WorksheetStatus } from '../../types'
import { canPerformWorksheetAction } from '../../utils/permissions'

type Props = {
  worksheet: WorksheetDetail
  mutateWorksheet: () => void
}

const VisibleStatuses: WorksheetStatus[] = ['dePresend']

export const SendWorksheet: React.FC<Props> = ({
  worksheet,
  mutateWorksheet,
}) => {
  const { isChanged } = useWorksheetValueContext()
  const {
    account: { member: currentMember, selectedTrialHospitalRole },
  } = useAuthenticatedAccount()

  const { isOpen, onOpen, onClose } = useDisclosure()
  const toast = useMirohaToast()

  const { request: sendWorksheet } = useSendWorksheet({
    onSuccess: () => {
      mutateWorksheet()
      onClose()
      toast({
        status: 'success',
        title: '指示を確定しました',
      })
    },
    onError: error => {
      toast({
        status: 'error',
        title: error.message,
      })
    },
  })

  if (
    !canPerformWorksheetAction(
      'deSend',
      currentMember.role,
      selectedTrialHospitalRole,
    )
  ) {
    return null
  }

  if (!VisibleStatuses.includes(worksheet.status)) {
    return null
  }

  return (
    <>
      <Button colorScheme="blue" isDisabled={isChanged} onClick={onOpen}>
        指示確定
      </Button>

      <Modal isOpen={isOpen} onClose={onClose} size="lg">
        <ModalOverlay />
        <ModalContent>
          <ModalCloseButton />
          <ModalHeader>
            <Text fontSize="xl" fontWeight="bold">
              指示を確定しますか？
            </Text>
          </ModalHeader>
          <ModalBody>
            <Text>
              指示確定後、パートナー医療機関で受領されるまでは内容の再編集が可能です。
            </Text>
            <Text>受領後は、内容の変更・再編集はできなくなります。</Text>
          </ModalBody>

          <ModalFooter>
            <ModalCancelButton />
            <Button
              colorScheme="blue"
              onClick={async () => {
                await sendWorksheet({ worksheetUid: worksheet.uid })
              }}
            >
              確定する
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  )
}
